/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Meta_Twittertitle1Inputs */

const ja_company_meta_twittertitle1 = /** @type {(inputs: Company_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN（株式会社プレイブレーン） | 会社概要`)
};

const en_company_meta_twittertitle1 = /** @type {(inputs: Company_Meta_Twittertitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - About Our Company`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - About Our Company" |
*
* @param {Company_Meta_Twittertitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_meta_twittertitle1 = /** @type {((inputs?: Company_Meta_Twittertitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Meta_Twittertitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_meta_twittertitle1(inputs)
	return en_company_meta_twittertitle1(inputs)
});
export { company_meta_twittertitle1 as "company_meta_twitterTitle" }